
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 17","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.231 2.018l2.64 4.885 2.897 5.361c.326.601.301 1.265-.065 1.842-.366.578-.968.901-1.672.901H2.965c-.704 0-1.306-.327-1.672-.9a1.766 1.766 0 01-.065-1.843l2.897-5.36 2.64-4.886c.346-.64.989-1.014 1.737-1.014.749 0 1.396.374 1.737 1.014h-.008z","fill":"#0E6199"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.23 2.018l1.721 3.188c-.085 4.222-4.796 7.628-10.602 7.628-.11 0-.224 0-.333-.004.032-.191.101-.382.199-.57L4.112 6.9l2.64-4.886C7.098 1.374 7.741 1 8.489 1c.749 0 1.396.375 1.737 1.014l.004.004z","fill":"#136FAD"}}),_c('path',{attrs:{"d":"M8.499 12.943c-.11 0-.216-.02-.314-.05a.982.982 0 01-.272-.153.7.7 0 01-.2-.261.844.844 0 01-.065-.328.743.743 0 01.244-.554.797.797 0 01.273-.172.906.906 0 01.647 0 .797.797 0 01.273.172.752.752 0 01.187.257.838.838 0 010 .628.734.734 0 01-.196.262.886.886 0 01-.581.21l.004-.011zM7.827 9.755L7.69 7.278c-.012-.234-.02-.445-.028-.625a10.749 10.749 0 01-.013-.429c0-.168.02-.32.057-.456.041-.145.102-.27.183-.375a.808.808 0 01.285-.238.791.791 0 01.35-.078.679.679 0 01.671.44c.05.126.086.27.11.438.025.164.033.347.033.55 0 .11-.004.23-.008.355a5.878 5.878 0 01-.025.36l-.183 2.547c-.012.16-.028.304-.053.433-.024.133-.057.25-.097.347a.66.66 0 01-.204.281.5.5 0 01-.297.098.487.487 0 01-.297-.094.596.596 0 01-.203-.277v-.004a1.894 1.894 0 01-.09-.347 4.966 4.966 0 01-.053-.44V9.754z","fill":"#fff"}})])
          )
        }
      }
    